module.exports = __webpack_public_path__ + "static/media/2022_4G8A1123.e8e27445.jpg";